import clsx from 'clsx'
import React, {useContext} from 'react'
import ClearableSelect from 'components/clearable-select'
import MenuItem from '@mui/material/MenuItem'

import {TeacherContext} from 'teacher/context'

export default function RepositoryFilter (props) {

  const {classes, onChange} = props
  const context = useContext(TeacherContext)
  const {translate} = context

  return (
    <ClearableSelect
      id="question-bank-repository-filter"
      className={clsx(classes.select, "repository")}
      value={context.query.repository || ""}
      onChange={onChange}
      caption={translate('repository')}
    >
      <MenuItem value="dreyfous">{translate('dreyfous')}</MenuItem>
      <MenuItem value="institution">{translate('institution')}</MenuItem>
      <MenuItem value="personal">{translate('personal')}</MenuItem>
    </ClearableSelect>
  )
}
